import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const generateGroupPDF = (group) => {
  try {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("TIRUMALA TIRUPATI DEVASTHANAM", 105, 20, { align: "center" });

    // Group Info
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Group Name: ${group.groupName || group.name}`, 14, 35);
    doc.text(`Group ID: ${group.accountId || group.groupId}`, 14, 43);
    doc.text(`Location: ${group.location}`, 14, 51);
    doc.text(`Total Members: ${group.members?.length || 0}`, 14, 59);

    // Table
    const tableColumn = [
      "S.No",
      "Account ID",
      "Name",
      "DOB",
      "Age",
      "Mobile",
      "Aadhar",
    ];
    const tableRows = [];

    group.members?.forEach((member, index) => {
      tableRows.push([
        index + 1,
        member.accountId,
        member.sevakName,
        member.dob,
        member.age,
        member.mobileNo,
        member.AdharNumber,
      ]);
    });

    autoTable(doc, {
      startY: 70,
      head: [tableColumn],
      body: tableRows,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [22, 160, 133] },
    });

    doc.save(`${group.groupName || "group"}_members.pdf`);
  } catch (error) {
    console.error("PDF generation failed:", error);
  }
};

export default generateGroupPDF;
